import cn from 'clsx'

import DocumentRow from './DocumentRow'

import useSortableTableHeaders from '@/hook/useSortableTableHeaders'
import { useEffect, useState, useMemo } from 'react'
import { sortBy } from '@/utils'
import Th from '@/components/shared/TableHeaderManager/Th'
import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import { useSearchParams } from 'react-router-dom'
import { getRunsheetDocsByTab } from '@/components/tract/Runsheet/Runsheet.lib'

const headers = [
    ['grantors', 'Grantor', false, '200px'],
    ['grantees', 'Grantee', false, '200px'],
    ['bookVolume', 'Book Volume', true, '90px'],
    ['bookPage', 'Book Page', true, '90px'],
    ['bookType', 'Book Type', true, '90px'],
    ['instrumentNumber', 'Instr. #', true, '90px'],
    ['instrumentType', 'Instr. Type', true, '90px'],
    ['instrumentDate', 'Instr. Date', true, '140px'],
    ['fileDate', 'File Date', true, '140px'],
    ['recordingDate', 'Recording Date', true, '140px'],
    ['legalDescriptions', 'Legal Description', false, '250px'],
    ['comment', 'Comments', false, '250px'],
]

const DocumentSearchRunsheetsTable = ({
    className,
    markedRunsheetDocs,
    setMarkedRunsheetDocs,
}) => {
    
    const [searchParams ] = useSearchParams()
    
    const runsheet = useWireValue(store.currentRunsheet)
    const runsheetHeaders = useWireValue(store.runsheetHeaders)
    const tabs = useWireValue(store.runsheetTabs)
    
    const activeTab = useMemo(() => searchParams.get('activeTab'), [searchParams])
    const currentTab = useMemo(() => tabs.find(t => t.id === activeTab) || tabs[0], [tabs, activeTab])
    
    const runsheetDocs = useMemo(() => 
        getRunsheetDocsByTab(currentTab, runsheet), 
    [runsheet, currentTab])
    
    
    const { onHeaderClick, orderDirection, orderField } = useSortableTableHeaders(headers)
    
    const sortedHeaders = useMemo(() => (
        runsheetHeaders.length
            ? runsheetHeaders.map(dh => headers.find(h => h[0] === dh)).filter(rh => !!rh)
            : headers
    ), [runsheetHeaders])
    const [sortedDocs, setSortedDocs] = useState([])
    
    
    useEffect (() => {
        if (runsheetDocs) {
            const sorted = sortBy(
                [...runsheetDocs], 
                orderField === 'name'
                    ? 'document.name'
                    : `value.${orderField}`,
                'natural',
                orderDirection === 'ASC',
            )
            
            setSortedDocs(sorted)
        }
        
    }, [orderField, orderDirection, runsheetDocs])
    
    return (
        
        <table className={cn(
            'DocumentSearchRunsheetsTable table table-sm table-nowrap table-pin-rows card-table', className)}>
            
            <thead>
                <tr className="top-[64px]">
                    <th>
                        <span className="mr-4">
                            <input
                                type="checkbox"
                                className="checkbox-tract"
                                checked={
                                    markedRunsheetDocs.length !== 0 &&
                                    markedRunsheetDocs.length === runsheetDocs.length
                                }
                                onChange={e => setMarkedRunsheetDocs(
                                    e.target.checked ? runsheetDocs.map(rd => rd.document.id) : [],
                                )} />
                        </span>
                    </th>
                    <Th
                        label="Viewer"
                        sortable={false} />
                    
                    <Th
                        className="90px"
                        key="name"
                        slug="name"
                        label="Name"
                        sortable={true}
                        onHeaderClick={onHeaderClick}
                        orderField={orderField}
                        orderDirection={orderDirection} />
                    
                    {sortedHeaders.map(([key, label, sortable, className]) => 
                        <Th
                            className={className}
                            key={key}
                            slug={key}
                            label={label}
                            sortable={sortable}
                            onHeaderClick={onHeaderClick}
                            orderField={orderField}
                            orderDirection={orderDirection} />)}   
                
                </tr>
            </thead>
            
            <tbody className="list-collection">
                {sortedDocs.length !== 0 &&
                    sortedDocs.map((rdj, i) => (
                        <DocumentRow
                            rsDocJoin={rdj}
                            key={i}
                            markedDocuments={markedRunsheetDocs}
                            setMarkedDocuments={setMarkedRunsheetDocs} />
                    ))}
            </tbody>
        
        </table>
        
    )
    
}

export default DocumentSearchRunsheetsTable
